import { getFormattedDate, isBetweenPeriod } from '../../../commons/datesUtils';

const getContractListItemByReservation = (reservation, contractsList) => {
  const { rateCode, fromDate } = reservation;

  if (rateCode === '') return undefined;

  if (fromDate === '') return undefined;

  if (!contractsList || contractsList.length === 0) return undefined;

  const filteredContract = contractsList.find((contractBean) => {
    const { rate, period } = contractBean;

    if (rateCode !== rate.code) return undefined;

    const dateToCheck = getFormattedDate(fromDate, 'DD/MM/YYYY', 'YYYY-MM-DD');

    if (!isBetweenPeriod(dateToCheck, period.dateFrom, period.dateTo, 'YYYY-MM-DD')) return undefined;

    return contractBean;
  });

  if (!filteredContract) return undefined;

  return filteredContract;
};

const getOptionsFromContractsList = (contractsList) => {
  if (!contractsList) return [];

  const mappedList = contractsList.map((contractBean) => { return contractBean.listItem; });

  return mappedList.filter(x => (x !== undefined));
};

export { getContractListItemByReservation, getOptionsFromContractsList };
